import { SET_DEPARTURE, SET_TOURID, SET_PRICE, SET_PASSENGER, SET_ADVENTURE_DEPARTURE, SET_TOURNAME, UPDATE_SECTOR_LOADING } from './types';

export function SetDeparture(value){
    return dispatch => dispatch({type:SET_DEPARTURE, payload:value});
}

export function SetTourID(value){
    return dispatch => dispatch({type:SET_TOURID, payload:value});
}

export function SetTourName(value){
    return dispatch => dispatch({type:SET_TOURNAME, payload:value});
}

export function SetPrices(value){
    return dispatch => dispatch({type:SET_PRICE, payload:value});
}

export function SetPassenger(value){
    return dispatch => dispatch({type:SET_PASSENGER, payload:value});
}

export function SetAdventureDeparture(value){
    return dispatch => dispatch({type:SET_ADVENTURE_DEPARTURE, payload:value});
}

export function SetSectorLoading(value){
    return dispatch => dispatch({type:UPDATE_SECTOR_LOADING, payload:value});
}